import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../service/storage.service';
import { LoadingService } from '../loading/loading.service';

/**
 * Interceptor HTTP global:
 *  - Adjunta el token de sesión (si existe) a los requests salientes.
 *  - Ante CUALQUIER error HTTP, oculta el spinner de carga. Antes,
 *    varios `.subscribe(...)` no tenían callback de error y el spinner
 *    quedaba colgado indefinidamente si el backend fallaba o no había red.
 *  - En un 401/403 limpia la sesión y redirige al login (sesión expirada).
 *
 * No muestra un toast genérico de error para no duplicar los mensajes
 * específicos que cada componente ya presenta en su propio manejador.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private storageService: StorageService,
    private loadingService: LoadingService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.storageService.getToken();
    const authReq = token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Red de seguridad: si el componente no oculta el spinner en su
        // propio callback de error, esto evita que quede colgado.
        this.loadingService.hide();

        if (error.status === 401 || error.status === 403) {
          this.storageService.removeUsuarioStorage();
          this.storageService.removeToken();
          this.toastr.error('Tu sesión expiró, vuelve a iniciar sesión', 'Sesión expirada');
          this.router.navigate(['/login']);
        } else {
          console.error('Error en la petición HTTP:', error);
        }
        return throwError(() => error);
      })
    );
  }
}
